export default {
    oidc: {
      url:process.env.VUE_APP_OKTA_URI ,
      clientId: process.env.VUE_APP_OKTA_CLIENT_ID ,
      issuer: process.env.VUE_APP_OKTA_ISSUER ,
      redirectUri: process.env.VUE_APP_OKTA_REDIRECT_URI ,
      scope: 'openid profile email',
      testing: {
        disableHttpsCheck: false
      }
    },
    resourceServer: {
      messagesUrl: 'http://localhost:8000/api/messages'
    }
  }
  